
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"125","height":"123","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M110.803 88.494c3.109 0 5.63 2.496 5.63 5.576 0 3.079-2.521 5.575-5.63 5.575s-5.63-2.496-5.63-5.575c0-3.08 2.521-5.576 5.63-5.576m-76.186 28.399c13.612 6.025 27.983 7.632 41.518 4.643a61.725 61.725 0 0029.13-15.412c1.69.762 3.56 1.198 5.538 1.198 7.39 0 13.38-5.932 13.38-13.252s-5.99-13.253-13.38-13.253c-7.39 0-13.38 5.933-13.38 13.253 0 2.052.485 3.988 1.326 5.722-15.858 14.76-39.058 18.302-60.407 8.84-10.696-4.744-19.162-13.356-23.85-24.252-3.246-7.582-4.867-15.365-4.867-22.947 0-10.243 2.94-20.16 8.744-28.846 9.86-14.737 26.387-23.55 44.205-23.55 27.324 0 50.44 21.014 52.747 47.928H95.282c-2.379-17.686-18.504-29.479-36.019-28.72a7.443 7.443 0 00-5-1.923c-4.11 0-7.442 3.3-7.442 7.372 0 4.071 3.332 7.371 7.442 7.371a7.45 7.45 0 006.06-3.102c13.293-.403 25.349 9.381 25.349 23.537 0 14.157-12.056 23.94-25.35 23.537a7.448 7.448 0 00-6.06-3.102c-4.11 0-7.441 3.3-7.441 7.372 0 4.071 3.332 7.372 7.442 7.372a7.45 7.45 0 005-1.923c17.526.758 33.66-11.049 36.023-28.753H115.6a9.017 9.017 0 006.565-2.838c1.647-1.782 2.508-4.166 2.306-6.577-1.242-15.39-8.212-29.65-19.67-40.17C93.295 5.825 78.29 0 62.575 0 41.688 0 22.299 10.318 10.765 27.616 3.947 37.834.5 49.457.5 61.433c0 8.812 1.85 17.776 5.602 26.513 5.575 13.004 15.714 23.272 28.515 28.947","fill":"#56BDD2","fill-rule":"evenodd"}})])
          )
        }
      }
    